import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocsAlert = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.66797 10H4.66797L6.0013 11.3333",
			stroke: "#FC6B6B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.66797 9.99935L6.0013 8.66602",
			stroke: "#FC6B6B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6654 6.66732V10.0007C14.6654 13.334 13.332 14.6673 9.9987 14.6673H5.9987C2.66536 14.6673 1.33203 13.334 1.33203 10.0007V6.00065C1.33203 2.66732 2.66536 1.33398 5.9987 1.33398H9.33203",
			stroke: "#FC6B6B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6654 6.66732H11.9987C9.9987 6.66732 9.33203 6.00065 9.33203 4.00065V1.33398L11.9987 4.00065L14.6654 6.66732Z",
			stroke: "#FC6B6B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgDocsAlert;
